import styles from "./LinesLeft.module.css"

export const LinesLeftSvg = () => {
    return (
        <div className={styles.div}>
        </div>
    )
}

